// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1_XZ1","cls2":"Cta-cls2_MK6 Cta-cls1_XZ1"};